import { classNames } from '@/util/tailwindHelpers'
import Icon, { Icons } from '../Icon'
import { ContextualMenuProps } from './types'

interface ContextualMenuItemContentProps {
  className?: string
  iconName?: Icons
  label: string | React.ReactNode
  hoverTheme?: ContextualMenuProps['appearance']['items']['hoverTheme']
  separator?: ContextualMenuProps['appearance']['items']['separator']
}

const ContextualMenuItemContent = ({
  className,
  iconName,
  label,
  hoverTheme = 'background',
  separator
}: ContextualMenuItemContentProps) => {
  return (
    <div
      className={classNames(
        'px-3 py-[12px] w-full flex gap-2 whitespace-nowrap items-center justify-start',
        {
          'relative before:content-[""] before:z-[-1] before:absolute before:left-[12px] before:right-[12px]':
            hoverTheme === 'background' || separator,
          'before:h-full group-hover:before:rounded-2xl group-hover:before:bg-gray-700':
            hoverTheme === 'background',
          'before:border-b-1 before:border-defaultBorder before:bottom-0 group-last:before:border-none':
            separator,
          'group-hover:text-gray-300': hoverTheme === 'darken'
        },
        className
      )}
    >
      {iconName && <Icon name={iconName} className="w-[20px] h-[20px]" />}
      {label}
    </div>
  )
}

export default ContextualMenuItemContent
